module.exports = __webpack_public_path__ + "img/Sci-Fi_2.d17f961c.png";